import React from 'react';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class PandariaProfessionLeveling1to600RankPicker extends React.PureComponent {
    static describeRank = rank => rank.toString();

    static minValue = 1;
    static maxValue = 600;

    static getDefaultValue = () => [525, 600];

    static marks = {
        1: '1',
        50: '50',
        150: '150',
        200: '200',
        300: '300',
        350: '350',
        425: '425',
        525: '525',
        600: '600',
    };

    render() {
        const {intl, collapsed, value, onChange} = this.props;

        return (
            <div>
                <div className="range-inputs">
                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.level'})}
                            min={PandariaProfessionLeveling1to600RankPicker.minValue}
                            max={PandariaProfessionLeveling1to600RankPicker.maxValue}
                            value={value[0]}
                            onChange={newValue => onChange([
                                newValue,
                                value[1]
                            ])}
                        />
                    </div>

                    <div className="range-inputs__divider"/>

                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.wanted'})}
                            min={PandariaProfessionLeveling1to600RankPicker.minValue}
                            max={PandariaProfessionLeveling1to600RankPicker.maxValue}
                            value={value[1]}
                            onChange={newValue => onChange([
                                value[0],
                                newValue
                            ])}
                        />
                    </div>
                </div>

                {!collapsed && (
                    <div className="slider">
                        <VariableStepRange
                            className="rc-slider-wow-leveling-classic"
                            step={1}
                            min={PandariaProfessionLeveling1to600RankPicker.minValue}
                            max={PandariaProfessionLeveling1to600RankPicker.maxValue}
                            marks={PandariaProfessionLeveling1to600RankPicker.marks}
                            value={value}
                            onChange={onChange}
                        />
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/wowLevelingPandaria/PandariaProfessionLeveling1to600RankPicker.js